// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2ZWaA","range":"MonthRangeSwitch_range__3hZWl","disabled":"MonthRangeSwitch_disabled__1Zmkk"};